export default "__VITE_ASSET__35da75cc__"